
import React, { Component } from 'react'
import {  Divider, Modal, Header, Button, Popup, Message, Card, Label, Input, Segment, Dropdown, Transition } from 'semantic-ui-react';
// import Chart from '../components/chart'
import '../App.css'
import {connect} from 'react-redux';
import Node from './node';
import {bindActionCreators} from 'redux';
import * as tokenActions from '../actions/actions';
import { toast } from 'react-toastify';
require('moment-timezone');

/*
    This component allows for the manual addition of new node(s) and realated node data i.e. node nu,ber, forest/location name, 
    coordniates vwc thresholds etc. 

*/


class Nodes extends Component {

    constructor(props){
        super(props);
        this.state = {
            nodeData: {},
            syncVisible:false,
            lastSync:'',
            isLoading:true,
            tempColor:'',
            currenNode:null,
            currentLimit:null,
            currentFromDate:null,
            currentToDate:null,
            searchList:[{'key':'', 'value':'', 'text':''}],
            currentNodes:null,
            transition:false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleAdd = this.handleAdd.bind(this);


    }

    componentDidMount(){
        this.props && this.props.nodeList &&
        this.setState({nodeData:this.props.nodeList, organisation:this.props.userOrg, userId:this.props.userId, isLoading:false}, () =>{
            let list = [];
            Object.keys(this.state.nodeData).forEach(key =>{
                    list.push({key:key , text:"N" + this.state.nodeData[key].node_num + "  F" + this.state.nodeData[key].forest_num + " "+ this.state.nodeData[key].forest_name, value:"N" + this.state.nodeData[key].node_num + "  F" + this.state.nodeData[key].forest_num + " "+ this.state.nodeData[key].forest_name})
            })
            this.setState({searchList:list})
        })
    }

    handleChange(e, data){
        e.preventDefault();
        let id  = data.id;
        if(id === "node_id"){
            this.setState({node_id:(data.value)})
        }
        if(id === "forest_name"){
            this.setState({forest_name:data.value})
        }
        if(id === "forest_id"){
            this.setState({forest_num:data.value})
        }
        if(id === "node_num"){
            this.setState({node_num:parseInt(data.value, 10)})
        }
        if(id === "lat_lng"){
            let str = data.value;
            str = str.replace(" ", "");
            let latlang = str.split(",")
            let parsedLatLng = latlang.map(i =>{
                return parseFloat(i,10)
            })

            this.setState({lat_lng:parsedLatLng})
        }

        if(id === "vwc30_low"){
            this.setState({vwc30_low:parseFloat(data.value)})
        }
        if(id === "vwc30_mid"){
            this.setState({vwc30_mid:parseFloat(data.value)})
        }
        if(id === "vwc30_high"){
            this.setState({vwc30_high:parseFloat(data.value)})
        }
        if(id === "vwc60_low"){
            this.setState({vwc60_low:parseFloat(data.value)})
        }
        if(id === "vwc60_mid"){
            this.setState({vwc60_mid:parseFloat(data.value)})
        }
        if(id === "vwc60_high"){
            this.setState({vwc60_high:parseFloat(data.value)})
        }
        if(id === "device_search"){
            let filteredNodes = data.options.filter((option) => option.value === data.value);
            filteredNodes && this.setState({currentNodes:filteredNodes, transition:!this.state.transition}, () =>{
                toast("Showing node(s) for " + data.value + "!", {
                    position: toast.POSITION.BOTTOM_CENTER
                });
            })


        }

    }
    handleAdd(e, data){
       
        e.preventDefault();
        let nodedata ={}
        let nodeId = null;
        
        // prepare the new payload. if the data fieds are empty  use the exsitging data. 
        try{
            nodeId = this.state.node_id || null;
            nodedata['forest_name'] = this.state.forest_name || null;
            nodedata['node_num'] = this.state.node_num || null;
            nodedata['forest_num'] =  this.state.forest_num || null;
            nodedata['lat_lng'] = this.state.lat_lng || null;

            nodedata['vwc30_low']  = this.state.vwc30_low || null;
            nodedata['vwc30_mid'] = this.state.vwc30_mid || null;
            nodedata['vwc30_high']  = this.state.vwc30_high || null;
            nodedata['vwc60_low'] = this.state.vwc60_low || null;
            nodedata['vwc60_mid'] = this.state.vwc60_mid || null;
            nodedata['vwc60_high'] = this.state.vwc60_high || null;
        } catch(e){
            toast.error("The form is invalid. Please enter the data in the correcct format shown!")
            return;
        }
         if(nodeId ===  null){
            toast.error("Node ID cannot be empty!");
        } else if (nodedata['node_num'] ===  null){
            toast.error("Node Number cannot be empty!");
        } else if (nodedata['forest_name'] ===  null || nodedata['forest_num'] === null){
            toast.error("Forest name or number cannot be empty!");
        } 
        else if(nodedata['lat_lng'] && nodedata['lat_lng'].length === 2){
            let error = false;
            nodedata['lat_lng'].forEach(i =>{
                if( isNaN(i)|| i === "NaN"){
                    error = true;
                    toast.error("Coordinates invalid! Please enter coordinates in the format shown!")
                } else{
                }
            })
            if(error === false){
                toast.info("Saving new node configuration..")
                this.props.tokenActions.addNode(this.state.userId, this.state.organisation, nodeId, nodedata);
            }
            
        } else{
            toast.warning("Form Invalid! Please populate the required fields correctly!")
        }

    }

    //generate individual elements for each datafileds.
    generateData(data){
        let dataFields = [];
        if(this.state.currentNodes){
            this.state.currentNodes.forEach(item =>{
                dataFields.push(
                        <Transition nimation={'bounce'} duration={500} visible={this.state.transition}>
                            <Node selfNode={data[item.key]} selfNodeId={item.key} userId ={this.state.userId} organisation={this.state.organisation}/>
                        </Transition>
                )
            })
        } else{
            dataFields.push(
                <Message info style={{marginLeft:"42%", marginTop:"200px"}}content={"Please Search for Nodes by Forest"}/>
            )
        }

        return dataFields;

    }

    render(){
        const {nodeData} = this.state;
        return(
            <div className = "" >
                <Divider/>
                <h3>Advanced device configurations</h3>
                <Divider/>
                <Modal trigger={
                    <Button icon ="add circle" style={{marginTop:'3px'}} color = 'teal' size ={'mini'}  content ={'Add New Device'} popup={'Add New Device'}/>
                }>
                <Modal.Header icon ='device'>Add New Device</Modal.Header>
                <Header>Mandatory fields are highlited below</Header>
                <Modal.Content scrolling >
                    <Segment  >
                        <Card.Content>
                            <Card.Description>
                                    Unique Node ID  
                                    <Input  error style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. bx3678123sac"}  id="node_id"/>
                            </Card.Description> 
                            <Card.Description>
                                    Node Number 
                                    <Input  error style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 5"}  id="node_num"/>
                            </Card.Description>   
                            <Card.Description>
                                    Forest / Location Name
                                    <Input error style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. Himalayan Cedar"}  id="forest_name"/>
                            </Card.Description>
                            <Card.Description>
                                    Forest / Location ID
                                    <Input error style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 032"}  id="forest_id"/>
                            </Card.Description>
                            <Card.Description>
                                    Coordinates
                                    <Input  error style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. -34.4231, 145.2312"}   id="lat_lng"/>
                            </Card.Description>
                            
                                    <Segment raised style ={{
                                        "borderBottomStyle":"solid",
                                        "borderBottomtWidth":"1px",
                                        "borderBottomColor":"orange",
                                            }}>
                                        <h4>VWC Thresholds for Heatmap</h4>
                                        <Button.Group  size='large' style={{maxWidth:"100%"}}>
                                            <Button style={{background:"#9b382b", color:"white"}}>Dry</Button>
                                            <Button style={{background:"#003f00", color:"white"}}>Normal</Button>
                                            <Button style={{background:"#0d3ab1", color:"white"}}>Wet</Button>
                                            <Button style={{background:"#00ffff", color:"white"}}>Very Wet</Button>
                                        </Button.Group>
                                        <Divider/>
                                        {/* <Card.Description>
                                            VWC 30 Low 
                                            <Input labelPosition='right' type='text'  style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 11.21"} id="vwc30_low">
                                            <input />
                                            <Label inverted>%</Label>
                                            </Input>
                                        </Card.Description>
                                        <Card.Description>
                                            VWC 30 Mid
                                            <Input labelPosition='right' type='text'  style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 21.22"}  id="vwc30_mid">
                                                <input />
                                                <Label>%</Label>
                                            </Input>
                                        </Card.Description>
                                        <Card.Description>
                                            VWC 30 High 
                                            <Input labelPosition='right' type='text'  style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 31.22"}   id="vwc30_high">
                                            <input />
                                            <Label>%</Label>
                                            </Input>
                                        </Card.Description> */}
                                        <Card.Description>
                                            VWC 60 Dry  - (Below threshold is dry. Above threshold is normal)
                                            <Input labelPosition='right' type='text'  style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 9.22"}   id="vwc60_low">
                                            <input />
                                            <Label>%</Label>
                                            </Input>
                                        </Card.Description>
                                        <Card.Description>
                                            VWC 60  Wet  - (Below threshold is normal. Above threshold is wet)
                                            <Input labelPosition='right' type='text'  style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 20.72"}   id="vwc60_mid">
                                            <input />
                                            <Label>%</Label>
                                            </Input>
                                        </Card.Description>
                                        <Card.Description>
                                            VWC 60 Very Wet  - (Below threshold is wet. Above threshold is very wet) 
                                            <Input labelPosition='right' type='text'  style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={"e.g. 41.27"}   id="vwc60_high">
                                            <input />
                                            <Label>%</Label>
                                            </Input>
                                        </Card.Description>

                                    </Segment>
                                    <Divider/>       
                                    </Card.Content>
                        </Segment>




                        </Modal.Content>







                        <Modal.Actions>
                            <Popup
                                trigger={<Button primary icon='save' content='Add Device' />}
                                content={ 
                                    <div>
                                        <Message info> Are you sure ?
                                            <Button style={{marginTop:'3px', float:'right', marginBottom:"10px"}} positive size ={'mini'} onClick={this.handleAdd} content={'Yes. Add Device.'}/>
                                        </Message>
                                       
                                    </div>
                                    
                                }
                                on='click'
                                position='top right'
                        />
                        </Modal.Actions>
                </Modal>
                <Divider/>
                <div id =""className = "" >
                    <div className = "ui stackable grid">
                        <br/>
                        <h4>List Nodes by Forest</h4>
                        <Dropdown style={{ marginLeft:"1%", width :'95%'}} placeholder='Forest Name'  id ='device_search'  onChange={this.handleChange} search selection options={this.state.searchList}/>
                    </div>
                    <div id ="nodeStack"className = "ui stackable grid" >
                        {nodeData && this.generateData(nodeData)}
                    </div>
                </div>
                
            </div>
            


        );
    }

}
function mapStateToProps(state) {
    return {
        ...state.initState
    };
}
function mapDispatchToProps(dispatch) {
    return {
        tokenActions: bindActionCreators(tokenActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    
)(Nodes);


// WEBPACK FOOTER //
// ./src/components/nodes.js